import jdHover from './img/京东金融colored.png';
import jdNormal from './img/京东金融gray.png';
import mgjHover from './img/蘑菇街colored.png';
import mgjNormal from './img/蘑菇街gray.png';
import carHover from './img/汽车报价大全colored.png';
import carNormal from './img/汽车报价大全gray.png';
import gameHover from './img/神魔大陆colored.png';
import gameNormal from './img/神魔大陆gray.png';

import gameScreenshot from './img/screenshot2.png';
import jdScreenshot from './img/screenshot4.png';
import mgjScreenshot from './img/screenshot3.png';
import carScreenshot from './img/screenshot1.png';

type DataItem = {
    readonly title: string;
    readonly value: number;
}[];

export const casesList = [
    {
        key: 0,
        title: '新神魔大陆',
        type: '游戏',
        desc: '《新神魔大陆》为完美世界旗舰级魔幻产品，于2020年7月在快手首发上线投放。',
        screenshot: gameScreenshot,
        icon: {
            hover: gameHover,
            normal: gameNormal,
        },
        content: {
            text:
                '客户针对魔幻题材定制人群包、根据历史优质重度游戏人群包进行逻辑运算后叠加lookalike使用，用户消费数和量级提升明显，ROI达成客户预期环比上涨20%并保持稳定，付费率提升9%。',
            data: [
                { title: 'ROI提升', value: 20 },
                { title: '付费率提升', value: 9 },
            ] as DataItem,
        },
    },
    {
        key: 1,
        title: '京东金融',
        type: '金融',
        desc:
            '京东金融是京东数字科技集团旗下个人金融业务品牌，以平台化、智能化、内容化为核心能力，与银行、保险公司、基金公司等近千家金融机构，共同为用户提供专业安全的个人金融服务。',
        screenshot: jdScreenshot,
        icon: {
            hover: jdHover,
            normal: jdNormal,
        },
        content: {
            text:
                '客户主投DMP人群管理、主题专区位置人群包，核心重点使用贷款意向、贷款强意向、贷款高学历净值人群进行投放，后续横向拓展：保险、P2P借贷、银行、信用卡类人群，结合媒体侧信用风险人群、客户侧自有种子人群包定投、排除，测试期前后激活成本下降11%，授信成本下降12%。',
            data: [
                { title: '激活成本下降', value: 5 },
                { title: '授信成本下降', value: 12 },
            ] as DataItem,
        },
    },
    {
        key: 2,
        title: '汽车报价大全',
        type: '交通',
        desc:
            '汽车报价大全App由易车官方出品，是提供新车/二手车价格，服务汽车生活的平台，为广大汽车消费者提供看车、选车、买车、用车、卖二手车等汽车相关服务。',
        screenshot: carScreenshot,
        icon: {
            hover: carHover,
            normal: carNormal,
        },
        content: {
            text:
                '客户在使用DMP潜在买车人群&有车人群主题专区人群包、并参考APP行为进行汽车行业人群定投跑量后，使用排除人群包排查已转化人群后，整体激活成本下降18%，后端咨询数提升10%，次留率明显上升。',
            data: [
                { title: '激活成本下降', value: 18 },
                { title: '后端咨询数提升', value: 10 },
            ] as DataItem,
        },
    },
    {
        key: 3,
        title: '蘑菇街',
        type: '电商',
        desc:
            '蘑菇街是一款专注于时尚女性消费者的电子商务网站，通过直播、短视频、社区等形式，累计已为超过3亿女性提供商品推荐、选款搭配服务。',
        screenshot: mgjScreenshot,
        icon: {
            hover: mgjHover,
            normal: mgjNormal,
        },
        content: {
            text:
                '客户在使用DMP的高次留率基础定向组合、网红粉丝标签定向、结合美妆服饰主题专区人群包、及电商高消费高净值人群后，后端次留率有效提升13%。',
            data: [{ title: '后端次留率提升', value: 13 }] as DataItem,
        },
    },
] as const;
